const narratives = [
  {
    title: "NSO Group's Early Years", // formerly Early Years
    text: "",
    date: "2010",
    highlightedCompanies: [],
    data: [
      {
        source: "NSO Group Technologies Ltd.",
        target: "PFOS Technologies Ltd.",
      },
    ],
  },

  {
    title: "Enter Francisco Partners", // formerly Pre-FP Prep and Francisco Partners Purchase
    text: "",
    date: "2014",
    highlightedCompanies: ["OSY Holdings Ltd."],
    data: [
      { source: "OSY Holdings Ltd.", target: "OSY Technologies SARL" },
      {
        source: "Francisco Partners III LP",
        target: "OSY Holdings Ltd.",
        type: "partial_ownership",
        percentage: 1,
      },
      { source: "OSY Technologies SARL", target: "L.E.G.D. Company Ltd." },
      {
        source: "L.E.G.D. Company Ltd.",
        target: "NSO Group Technologies Ltd.",
        type: "Majority Shareholder",
      },
      {
        source: "NSO Group Technologies Ltd.",
        target: "PFOS Technologies Ltd.",
      },
    ],
  },
  {
    title: "Expansion Under Francisco Partners", // Formerly Continued Expansion and Ownership Adjustments
    text: "",
    date: "2014–2016",
    highlightedCompanies: ["OSY Technologies SARL"],
    data: [
      { source: "OSY Holdings Ltd.", target: "Triangle Holdings SA" },
      {
        source: "Global Seven Group LP",
        target: "Triangle Holdings SA",
        type: "partial_ownership",
        percentage: 12,
      },
      {
        source: "Alexei Voronovitsky",
        target: "Triangle Holdings SA",
        type: "partial_ownership",
        percentage: 0.1,
      },
      {
        source: "Shalev Hulio",
        target: "Triangle Holdings SA",
        type: "partial_ownership",
        percentage: 9,
      },
      {
        source: "Eddy Shalev",
        target: "Triangle Holdings SA",
        type: "partial_ownership",
        percentage: 1.8,
      },
      {
        source: "Omri Lavie",
        target: "Triangle Holdings SA",
        type: "partial_ownership",
      },
      {
        source: "Eran Gorev",
        target: "Triangle Holdings SA",
        type: "partial_ownership",
        percentage: 0.8,
      },
      {
        source: "ESOP Mgmt. & Trust",
        target: "Triangle Holdings SA",
        type: "partial_ownership",
        percentage: 2.8,
      },
      { source: "Triangle Holdings SA", target: "Square 2 SARL" },
      { source: "Square 2 SARL", target: "OSY Technologies SARL" },
      {
        source: "OSY Technologies SARL",
        target: "Q Cyber Technologies SARL",
      },
      {
        source: "OSY Technologies SARL",
        target: "Westbridge Technologies Inc.",
      },

      { source: "OSY Technologies SARL", target: "IOTA Holdings Ltd." },
      {
        source: "OSY Technologies SARL",
        target: "Q Cyber Technologies Ltd.",
      },
      { source: "OSY Technologies SARL", target: "Shapes 1 BV" },
      { source: "OSY Technologies SARL", target: "Shapes 2 BV" },
      {
        source: "Q Cyber Technologies Ltd.",
        target: "NSO Group Technologies Ltd.",
      },
      {
        source: "NSO Group Technologies Ltd.",
        target: "PFOS Technologies Ltd.",
      },
      { source: "IOTA Holdings Ltd.", target: "CS-Circles Solutions Ltd." },
      { source: "IOTA Holdings Ltd.", target: "MS Magnet Solutions Ltd." },
      { source: "IOTA Holdings Ltd.", target: "Global Hubcom Ltd." },
      { source: "CS-Circles Solutions Ltd.", target: "CI Compass Ltd." },
      {
        source: "CS-Circles Solutions Ltd.",
        target: "Circles Bulgaria EOOD",
      },
      {
        source: "MS Magnet Solutions Ltd.",
        target: "Magnet Bulgaria EOOD",
      },
      { source: "MS Magnet Solutions Ltd.", target: "MI Compass Ltd." },
    ],
  },

  {
    title: "Investment by Novalpina Capital", // formerly Bringing Together Novalpina and NSO
    text: "",
    date: "2019",
    highlightedCompanies: [
      "NorthPole HoldCo SARL",
      "NorthPole Bidco SARL",
      "NorthPole Newco SARL",
    ],
    data: [
      {
        source: "Global Seven Group LP",
        target: "Triangle Holdings SA",
        type: "partial_ownership",
        percentage: 12,
      },
      {
        source: "Alexei Voronovitsky",
        target: "Triangle Holdings SA",
        type: "partial_ownership",
      },
      {
        source: "Shalev Hulio",
        target: "Triangle Holdings SA",
        type: "partial_ownership",
      },
      {
        source: "Eddy Shalev",
        target: "Triangle Holdings SA",
        type: "partial_ownership",
      },
      {
        source: "Omri Lavie",
        target: "Triangle Holdings SA",
        type: "partial_ownership",
      },
      { source: "Triangle Holdings SA", target: "Square 2 SARL" },
      {
        source: "NorthPole HoldCo SARL",
        target: "Square 2 SARL",
        type: "partial_ownership",
        percentage: 68.6,
      },
      { source: "Square 2 SARL", target: "NorthPole Bidco SARL" },
      { source: "NorthPole Bidco SARL", target: "NorthPole Newco SARL" },
      { source: "NorthPole Newco SARL", target: "OSY Technologies SARL" },
      {
        source: "OSY Technologies SARL",
        target: "Westbridge Technologies Inc.",
      },
      { source: "OSY Technologies SARL", target: "IOTA Holdings Ltd." },
      {
        source: "OSY Technologies SARL",
        target: "Q Cyber Technologies SARL",
      },
      {
        source: "OSY Technologies SARL",
        target: "Q Cyber Technologies Ltd.",
      },
      {
        source: "Q Cyber Technologies Ltd.",
        target: "NSO Group Technologies Ltd.",
      },
      {
        source: "NSO Group Technologies Ltd.",
        target: "PFOS Technologies Ltd.",
      },
      { source: "IOTA Holdings Ltd.", target: "CS-Circles Solutions Ltd." },
      { source: "IOTA Holdings Ltd.", target: "MS Magnet Solutions Ltd." },
      { source: "IOTA Holdings Ltd.", target: "Global Hubcom Ltd." },
      { source: "CS-Circles Solutions Ltd.", target: "CI Compass Ltd." },
      {
        source: "CS-Circles Solutions Ltd.",
        target: "Circles Bulgaria EOOD",
      },
      {
        source: "MS Magnet Solutions Ltd.",
        target: "Magnet Bulgaria EOOD",
      },
      { source: "MS Magnet Solutions Ltd.", target: "MI Compass Ltd." },
    ],
  },

  {
    title: "Recent Developments", // formerly Further Refinements
    text: "",
    date: "2019–2020",
    highlightedCompanies: [],
    data: [
      {
        source: "Kevin Wilson",
        target: "Triangle Holdings SA",
        type: "partial_ownership",
      },
      {
        source: "Shalev Hulio",
        target: "Triangle Holdings SA",
        type: "partial_ownership",
      },
      {
        source: "Eddy Shalev",
        target: "Triangle Holdings SA",
        type: "partial_ownership",
      },
      {
        source: "Omri Lavie",
        target: "Triangle Holdings SA",
        type: "partial_ownership",
      },
      {
        source: "NorthPole HoldCo SARL",
        target: "Triangle Holdings SA",
        // type: "partial_ownership",
      },
      { source: "Triangle Holdings SA", target: "Square 2 SARL" },
      { source: "Square 2 SARL", target: "NorthPole Bidco SARL" },
      { source: "NorthPole Bidco SARL", target: "Emerald LIE SARL" },
      {
        source: "ESOP Mgmt. & Trust",
        target: "Emerald LIE SARL",
        type: "partial_ownership",
      }, // TODO Add after initial positioning
      { source: "Emerald LIE SARL", target: "Diamond LIE SARL" },
      {
        source: "Diamond LIE SARL",
        target: "Goatilev Ltd.",
        // type: "partial_ownership",
      },
      {
        source: "Diamond LIE SARL",
        target: "NorthPole Newco SARL",
      },
      { source: "NorthPole Newco SARL", target: "OSY Technologies SARL" },
      {
        source: "OSY Technologies SARL",
        target: "Westbridge Technologies Inc.",
      },
      { source: "OSY Technologies SARL", target: "IOTA Holdings Ltd." },
      {
        source: "OSY Technologies SARL",
        target: "Q Cyber Technologies SARL",
      },
      {
        source: "OSY Technologies SARL",
        target: "Q Cyber Technologies Ltd.",
      },
      {
        source: "Q Cyber Technologies Ltd.",
        target: "NSO Group Technologies Ltd.",
      },
      { source: "Q Cyber Technologies Ltd.", target: "NGTP Ltd." },
      {
        source: "Q Cyber Technologies Ltd.",
        target: "S. Sesame Technology",
      },
      {
        source: "NSO Group Technologies Ltd.",
        target: "PFOS Technologies Ltd.",
      },
      { source: "NSO Group Technologies Ltd.", target: "Convexum Ltd." },
      { source: "IOTA Holdings Ltd.", target: "CS-Circles Solutions Ltd." },
      { source: "IOTA Holdings Ltd.", target: "MS Magnet Solutions Ltd." },
      { source: "IOTA Holdings Ltd.", target: "Global Hubcom Ltd." },
      { source: "CS-Circles Solutions Ltd.", target: "CI Compass Ltd." },
      {
        source: "CS-Circles Solutions Ltd.",
        target: "Circles Bulgaria EOOD",
      },
      {
        source: "MS Magnet Solutions Ltd.",
        target: "Magnet Bulgaria EOOD",
      },
      { source: "MS Magnet Solutions Ltd.", target: "MI Compass Ltd." },
    ],
  },
];

export default narratives;
